module.exports = __webpack_public_path__ + "img/show-tags.74eae5ee.svg";